export default __webpack_public_path__ + "static/media/ArrowNoCircle.a823ba97.svg";